import { render, staticRenderFns } from "./TypeBenefitCreate.vue?vue&type=template&id=4d00af9f&"
import script from "./TypeBenefitCreate.vue?vue&type=script&lang=js&"
export * from "./TypeBenefitCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports